module.exports = __webpack_public_path__ + "media/images/icons/icon_panier_off-890a84834a719fc6805390aea7b7ce00.svg";